import { useState } from 'react';
import Modal from '@common/modal';
import Step1 from './step1';
import Step2 from './step2';

export type UserDeleteModalStep = 'STEP1' | 'STEP2';

interface IUserDeleteModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UserDeleteModal = ({ visible, onClose, onConfirm }: IUserDeleteModalProps) => {
  const [step, setStep] = useState<UserDeleteModalStep>('STEP1');

  const handleClose = () => {
    setStep('STEP1');
    onClose();
  };

  const getStepEl = () => {
    switch (step) {
      case 'STEP1':
        return <Step1 onClose={handleClose} onContinue={() => setStep('STEP2')} />;
      case 'STEP2':
        return <Step2 onClose={handleClose} onConfirm={onConfirm} />;
      default:
        return null;
    }
  };

  if (!visible) return null;

  return <Modal visible={visible}>{getStepEl()}</Modal>;
};

export default UserDeleteModal;
